import {
    GET_MAPPING_SETS_REQUEST,
    GET_MAPPING_SETS_SUCCESS,
    GET_MAPPING_SETS_ERROR,
    GET_MAPPING_SET_REQUEST,
    GET_MAPPING_SET_SUCCESS,
    GET_MAPPING_SET_ERROR,
    CREATE_MAPPING_SET_REQUEST,
    CREATE_MAPPING_SET_SUCCESS,
    CREATE_MAPPING_SET_ERROR,
    UPDATE_MAPPING_SET_REQUEST,
    UPDATE_MAPPING_SET_SUCCESS,
    UPDATE_MAPPING_SET_ERROR,
    DELETE_MAPPING_SET_REQUEST,
    DELETE_MAPPING_SET_SUCCESS,
    DELETE_MAPPING_SET_ERROR,
    GET_MAPPING_SET_RULES_REQUEST,
    GET_MAPPING_SET_RULES_SUCCESS,
    GET_MAPPING_SET_RULES_ERROR,
    CREATE_MAPPING_RULE_REQUEST,
    CREATE_MAPPING_RULE_SUCCESS,
    CREATE_MAPPING_RULE_ERROR,
    UPDATE_MAPPING_RULE_REQUEST,
    UPDATE_MAPPING_RULE_SUCCESS,
    UPDATE_MAPPING_RULE_ERROR,
    DELETE_MAPPING_RULE_REQUEST,
    DELETE_MAPPING_RULE_SUCCESS,
    DELETE_MAPPING_RULE_ERROR,
    GET_VALUE_TRANSFORMS_REQUEST,
    GET_VALUE_TRANSFORMS_SUCCESS,
    GET_VALUE_TRANSFORMS_ERROR,
    CREATE_VALUE_TRANSFORM_REQUEST,
    CREATE_VALUE_TRANSFORM_SUCCESS,
    CREATE_VALUE_TRANSFORM_ERROR,
    UPDATE_VALUE_TRANSFORM_REQUEST,
    UPDATE_VALUE_TRANSFORM_SUCCESS,
    UPDATE_VALUE_TRANSFORM_ERROR,
    DELETE_VALUE_TRANSFORM_REQUEST,
    DELETE_VALUE_TRANSFORM_SUCCESS,
    DELETE_VALUE_TRANSFORM_ERROR,
    CREATE_VENDOR_ERROR,
    CREATE_VENDOR_REQUEST,
    CREATE_VENDOR_SUCCESS,
    DELETE_VENDOR_ERROR,
    DELETE_VENDOR_REQUEST,
    DELETE_VENDOR_SUCCESS,
    GET_VENDORS_ERROR,
    GET_VENDORS_REQUEST,
    GET_VENDORS_SUCCESS,
    GET_VENDOR_ERROR,
    GET_VENDOR_REQUEST,
    GET_VENDOR_SUCCESS,
    UPDATE_VENDOR_ERROR,
    UPDATE_VENDOR_REQUEST,
    UPDATE_VENDOR_SUCCESS,
    GET_MAPPING_SETS_BY_VENDOR_SUCCESS,
    GET_MAPPING_SETS_BY_VENDOR_ERROR,
    MAPPING_SETS_SAVE_ALL_SUCCESS,
    SAVE_POWERFAIDS_CONFIG_REQUEST,
    GET_POE_TOKEN_OPTIONS_SUCCESS,
    GET_POE_TOKEN_OPTIONS_REQUEST,
    GET_POE_TOKEN_OPTIONS_ERROR,
    SAVE_POWERFAIDS_CONFIG_SUCCESS,
    GET_POWERFAIDS_CONFIG_SUCCESS,
    GET_POWERFAIDS_CONFIG_REQUEST,
    GET_POWERFAIDS_CONFIG_SELECT_ITEMS_REQUEST,
    GET_POWERFAIDS_CONFIG_SELECT_ITEMS_SUCCESS,
    GET_POWERFAIDS_CONFIG_SELECT_ITEMS_ERROR,
    UPDATE_POWERFAIDS_CONFIG_SUCCESS,
    GET_CONNECTOR_ERRORS_REQUEST,
    GET_CONNECTOR_ERRORS_SUCCESS,
    GET_CONNECTOR_ERRORS_FAILURE,
    LOAD_MORE_CONNECTOR_ERRORS_SUCCESS,
    RETRY_ERROR_REQUEST,
    RETRY_ERROR_SUCCESS,
    RETRY_ERROR_FAILURE,
    REMOVE_DUPLICATE_ERRORS_REQUEST,
    REMOVE_DUPLICATE_ERRORS_SUCCESS,
    REMOVE_DUPLICATE_ERRORS_FAILURE,
    GET_VENDOR_CREDENTIALS_REQUEST,
    GET_VENDOR_CREDENTIALS_SUCCESS,
    GET_VENDOR_CREDENTIALS_ERROR,
    GET_FILEDROP_KEY_SUCCESS,
    CREATE_FILEDROP_KEY_SUCCESS,
    REVOKE_FILEDROP_KEY_SUCCESS,
    CLEAR_REVEALED_FILEDROP_KEY,
} from './types';

const initialState = {
    mappingSets: [],
    mappingSet: null,
    mappingSetRules: [],
    mappingRule: null,
    valueTransforms: [],
    valueTransform: null,
    vendors: [],
    vendor: null,
    loading: false,
    error: null,
    poeTokenOptions: [],
    powerfaidsConfig: null,
    powerfaidsConfigSelectItems: null,
    // URLs plus the active key's metadata (or key: null when none has been issued).
    fileDropConnection: null,
    // Held only until the user dismisses the "copy it now" panel; never re-fetchable.
    revealedFileDropKey: null,
    vendorCredentials: {},
    loadingCredentials: false,
    credentialsError: null,
    connectorErrors: {
        data: null,
        loading: false,
        error: null
    },
    retryError: {
        loading: false,
        error: null
    },
    removeDuplicates: {
        loading: false,
        error: null
    }
};

const customMappingsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // --- Mapping Sets ---
        case GET_MAPPING_SETS_REQUEST:
        case GET_MAPPING_SET_REQUEST:
        case CREATE_MAPPING_SET_REQUEST:
        case UPDATE_MAPPING_SET_REQUEST:
        case DELETE_MAPPING_SET_REQUEST:
        case GET_MAPPING_SET_RULES_REQUEST:
        case CREATE_MAPPING_RULE_REQUEST:
        case UPDATE_MAPPING_RULE_REQUEST:
        case DELETE_MAPPING_RULE_REQUEST:
        case GET_VALUE_TRANSFORMS_REQUEST:
        case CREATE_VALUE_TRANSFORM_REQUEST:
        case UPDATE_VALUE_TRANSFORM_REQUEST:
        case DELETE_VALUE_TRANSFORM_REQUEST:
        case GET_POE_TOKEN_OPTIONS_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_MAPPING_SETS_SUCCESS:
        case GET_MAPPING_SETS_BY_VENDOR_SUCCESS:
            return { ...state, loading: false, mappingSets: payload.mappingSets };
        case GET_MAPPING_SET_SUCCESS:
            return { ...state, loading: false, mappingSet: payload };
        case CREATE_MAPPING_SET_SUCCESS:
            return { ...state, loading: false, mappingSets: [...state.mappingSets, payload] };
        case UPDATE_MAPPING_SET_SUCCESS:
            return {
                ...state,
                loading: false,
                mappingSets: state.mappingSets.map(set => set.id === payload.id ? payload : set)
            };
        case DELETE_MAPPING_SET_SUCCESS:
            return {
                ...state,
                loading: false,
                mappingSets: state.mappingSets.filter(set => set.id !== payload)
            };
        case MAPPING_SETS_SAVE_ALL_SUCCESS:
            return { ...state, loading: false, mappingSets: payload };

        // --- Mapping Rules ---
        case GET_MAPPING_SET_RULES_SUCCESS:
            return { ...state, loading: false, mappingSetRules: payload };
        case CREATE_MAPPING_RULE_SUCCESS:
            return { ...state, loading: false, mappingSetRules: [...state.mappingSetRules, payload] };
        case UPDATE_MAPPING_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                mappingSetRules: state.mappingSetRules.map(rule => rule.id === payload.id ? payload : rule)
            };
        case DELETE_MAPPING_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                mappingSetRules: state.mappingSetRules.filter(rule => rule.id !== payload)
            };

        // --- Value Transforms ---
        case GET_VALUE_TRANSFORMS_SUCCESS:
            return { ...state, loading: false, valueTransforms: payload };
        case CREATE_VALUE_TRANSFORM_SUCCESS:
            return { ...state, loading: false, valueTransforms: [...state.valueTransforms, payload] };
        case UPDATE_VALUE_TRANSFORM_SUCCESS:
            return {
                ...state,
                loading: false,
                valueTransforms: state.valueTransforms.map(val => val.id === payload.id ? payload : val)
            };
        case DELETE_VALUE_TRANSFORM_SUCCESS:
            return {
                ...state,
                loading: false,
                valueTransforms: state.valueTransforms.filter(val => val.id !== payload)
            };

        case GET_VENDORS_REQUEST:
        case GET_VENDOR_REQUEST:
        case CREATE_VENDOR_REQUEST:
        case UPDATE_VENDOR_REQUEST:
        case DELETE_VENDOR_REQUEST:
        case SAVE_POWERFAIDS_CONFIG_REQUEST:
        case GET_POWERFAIDS_CONFIG_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_VENDORS_SUCCESS:
            return { ...state, loading: false, vendors: payload.vendors };
        case GET_VENDOR_SUCCESS:
            return { ...state, loading: false, vendor: payload };
        case CREATE_VENDOR_SUCCESS:
            return { ...state, loading: false, vendors: [...state.vendors, payload] };
        case UPDATE_VENDOR_SUCCESS:
            return {
                ...state,
                loading: false,
                vendors: state.vendors.map(v => v.id === payload.id ? payload : v)
            };
        case DELETE_VENDOR_SUCCESS:
            return {
                ...state,
                loading: false,
                vendors: state.vendors.filter(v => v.id !== payload)
            };
        case GET_POE_TOKEN_OPTIONS_SUCCESS:
            return { ...state, loading: false, poeTokenOptions: payload };
        case SAVE_POWERFAIDS_CONFIG_SUCCESS:
            return { ...state, loading: false };
        case UPDATE_POWERFAIDS_CONFIG_SUCCESS:
            return { ...state, loading: false, powerfaidsConfig: payload };
        case GET_POWERFAIDS_CONFIG_SUCCESS:
            return { ...state, loading: false, powerfaidsConfig: payload };

        case GET_FILEDROP_KEY_SUCCESS:
            return { ...state, loading: false, fileDropConnection: payload };

        // Create returns the key only; the URLs on state are unaffected by issuing one.
        case CREATE_FILEDROP_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                fileDropConnection: { ...(state.fileDropConnection || {}), key: payload },
                revealedFileDropKey: payload?.apiKey ?? null
            };

        case REVOKE_FILEDROP_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                fileDropConnection: { ...(state.fileDropConnection || {}), key: null },
                revealedFileDropKey: null
            };

        case CLEAR_REVEALED_FILEDROP_KEY:
            return { ...state, revealedFileDropKey: null };

        // --- Errors ---
        case GET_MAPPING_SETS_ERROR:
        case GET_MAPPING_SET_ERROR:
        case GET_MAPPING_SETS_BY_VENDOR_ERROR:
        case CREATE_MAPPING_SET_ERROR:
        case UPDATE_MAPPING_SET_ERROR:
        case DELETE_MAPPING_SET_ERROR:
        case GET_MAPPING_SET_RULES_ERROR:
        case CREATE_MAPPING_RULE_ERROR:
        case UPDATE_MAPPING_RULE_ERROR:
        case DELETE_MAPPING_RULE_ERROR:
        case GET_VALUE_TRANSFORMS_ERROR:
        case CREATE_VALUE_TRANSFORM_ERROR:
        case UPDATE_VALUE_TRANSFORM_ERROR:
        case DELETE_VALUE_TRANSFORM_ERROR:
        case GET_VENDORS_ERROR:
        case GET_VENDOR_ERROR:
        case CREATE_VENDOR_ERROR:
        case UPDATE_VENDOR_ERROR:
        case DELETE_VENDOR_ERROR:
        case GET_POE_TOKEN_OPTIONS_ERROR:
            return { ...state, loading: false, error: true };

        case GET_POWERFAIDS_CONFIG_SELECT_ITEMS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_POWERFAIDS_CONFIG_SELECT_ITEMS_SUCCESS:
            return { ...state, loading: false, powerfaidsConfigSelectItems: payload };
        case GET_POWERFAIDS_CONFIG_SELECT_ITEMS_ERROR:
            return { ...state, loading: false, error: true };

        // Connector Errors
        case GET_CONNECTOR_ERRORS_REQUEST:
            return {
                ...state,
                connectorErrors: {
                    ...state.connectorErrors,
                    loading: true,
                    error: null
                }
            };
        case GET_CONNECTOR_ERRORS_SUCCESS:
            return {
                ...state,
                connectorErrors: {
                    data: payload,
                    loading: false,
                    error: null
                }
            };
        case LOAD_MORE_CONNECTOR_ERRORS_SUCCESS:
            return {
                ...state,
                connectorErrors: {
                    data: {
                        ...payload,
                        errors: [
                            ...(state.connectorErrors.data?.errors || []),
                            ...payload.errors
                        ]
                    },
                    loading: false,
                    error: null
                }
            };
        case GET_CONNECTOR_ERRORS_FAILURE:
            return {
                ...state,
                connectorErrors: {
                    ...state.connectorErrors,
                    loading: false,
                    error: payload
                }
            };

        // Retry Error
        case RETRY_ERROR_REQUEST:
            return {
                ...state,
                retryError: {
                    loading: true,
                    error: null
                }
            };
        case RETRY_ERROR_SUCCESS:
            return {
                ...state,
                retryError: {
                    loading: false,
                    error: null
                }
            };
        case RETRY_ERROR_FAILURE:
            return {
                ...state,
                retryError: {
                    loading: false,
                    error: payload
                }
            };

        // Remove Duplicates
        case REMOVE_DUPLICATE_ERRORS_REQUEST:
            return {
                ...state,
                removeDuplicates: {
                    loading: true,
                    error: null
                }
            };
        case REMOVE_DUPLICATE_ERRORS_SUCCESS:
            return {
                ...state,
                removeDuplicates: {
                    loading: false,
                    error: null
                }
            };
        case REMOVE_DUPLICATE_ERRORS_FAILURE:
            return {
                ...state,
                removeDuplicates: {
                    loading: false,
                    error: payload
                }
            };

        // Vendor Credentials
        case GET_VENDOR_CREDENTIALS_REQUEST:
            return {
                ...state,
                loadingCredentials: true,
                credentialsError: null,
            };

        case GET_VENDOR_CREDENTIALS_SUCCESS:
            return {
                ...state,
                loadingCredentials: false,
                vendorCredentials: payload,
            };

        case GET_VENDOR_CREDENTIALS_ERROR:
            return {
                ...state,
                loadingCredentials: false,
                credentialsError: payload,
            };

        default:
            return state;
    }
};

export default customMappingsReducer;